import React from 'react'

import styled from 'styled-components'
import { useTrackMutation } from '@mote/api'

export const TrackedDownloadLink = props => {
  const { mutate: track } = useTrackMutation()

  const href = props.href
  const label = props.label
  const title = props.title
  return (
    <Link
      target='_new'
      href={href}
      onClick={() => {
        track({
          variables: {
            event: 'Download Link',
            label: label,
            href: href,
            title: title
          }
        })
      }}
    >
      {label}
    </Link>
  )
}

const Link = styled.a`
  text-transform: uppercase;
  text-decoration: underline;
  color: #ac0ae8;

  &:hover,
  &:focus,
  &:visited {
    color: #ac0ae8;
  }

  &:hover {
    text-decoration: none;
  }
`
